import { Api } from '@deepcloud/api-base'
import type {
  HttpClient,
  HttpClientRequestConfig,
} from '@deepcloud/http-client'
import type {
  NotificationSettingsOut,
  NotificationSettingUpdate,
} from '../../@types'

export class NotificationsAPI extends Api {
  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  /**
   * Get Notification Settings
   * -------------------
   * Errors:
   * - none documented
   */
  async getSettings(config?: HttpClientRequestConfig) {
    const path = `/notifications/settings`

    return this.httpClient.get<NotificationSettingsOut>(path, config)
  }

  /**
   * Update Notification Settings
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async updateSettings(
    payload: NotificationSettingUpdate[],
    config?: HttpClientRequestConfig,
  ) {
    const path = `/notifications/settings`

    return this.httpClient.put<Record<string, string>>(path, payload, config)
  }
}
